import React from 'react';
import Hero from '../components/Hero/Hero';
import Destinations from '../components/Destination/Destinations';
import TourPackages from '../components/TourPackages/TourPackages';
import Gallery from '../components/Gallery/Gallery';
import Services from '../components/Services/Services';
import Awards from '../components/Awards/Awards';

const Home = () => {
    return (
        <>
            <Hero />
            <Destinations />
            <TourPackages />
            <Gallery />
            <Services />
            <Awards />
        </>
    );
};

export default Home;